/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReproductiveHealthDayUpsertDto
 */
export interface ReproductiveHealthDayUpsertDto {
    /**
     * Calendar date to update in YYYY-MM-DD format.
     * @type {string}
     * @memberof ReproductiveHealthDayUpsertDto
     */
    date: string;
    /**
     * Whether the selected date has spotting.
     * @type {boolean}
     * @memberof ReproductiveHealthDayUpsertDto
     */
    spotting: boolean;
    /**
     * Whether the selected date has menstrual flow.
     * @type {boolean}
     * @memberof ReproductiveHealthDayUpsertDto
     */
    menstrualFlow: boolean;
    /**
     * Timezone offset in HHMM format. The date is interpreted in this offset.
     * @type {string}
     * @memberof ReproductiveHealthDayUpsertDto
     */
    timezoneOffset?: string;
    /**
     * Source for this manual update. Defaults to apple-healthkit until a dedicated manual source is added.
     * @type {string}
     * @memberof ReproductiveHealthDayUpsertDto
     */
    healthProviderCode?: ReproductiveHealthDayUpsertDtoHealthProviderCodeEnum;
}


/**
 * @export
 */
export const ReproductiveHealthDayUpsertDtoHealthProviderCodeEnum = {
    AppleHealthkit: 'apple-healthkit',
    GoogleHealthConnect: 'google-health-connect'
} as const;
export type ReproductiveHealthDayUpsertDtoHealthProviderCodeEnum = typeof ReproductiveHealthDayUpsertDtoHealthProviderCodeEnum[keyof typeof ReproductiveHealthDayUpsertDtoHealthProviderCodeEnum];


/**
 * Check if a given object implements the ReproductiveHealthDayUpsertDto interface.
 */
export function instanceOfReproductiveHealthDayUpsertDto(value: object): value is ReproductiveHealthDayUpsertDto {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('spotting' in value) || value['spotting'] === undefined) return false;
    if (!('menstrualFlow' in value) || value['menstrualFlow'] === undefined) return false;
    return true;
}

export function ReproductiveHealthDayUpsertDtoFromJSON(json: any): ReproductiveHealthDayUpsertDto {
    return ReproductiveHealthDayUpsertDtoFromJSONTyped(json, false);
}

export function ReproductiveHealthDayUpsertDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReproductiveHealthDayUpsertDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'spotting': json['spotting'],
        'menstrualFlow': json['menstrualFlow'],
        'timezoneOffset': json['timezoneOffset'] == null ? undefined : json['timezoneOffset'],
        'healthProviderCode': json['healthProviderCode'] == null ? undefined : json['healthProviderCode'],
    };
}

export function ReproductiveHealthDayUpsertDtoToJSON(json: any): ReproductiveHealthDayUpsertDto {
    return ReproductiveHealthDayUpsertDtoToJSONTyped(json, false);
}

export function ReproductiveHealthDayUpsertDtoToJSONTyped(value?: ReproductiveHealthDayUpsertDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'spotting': value['spotting'],
        'menstrualFlow': value['menstrualFlow'],
        'timezoneOffset': value['timezoneOffset'],
        'healthProviderCode': value['healthProviderCode'],
    };
}

